import React from "react";

export default function CompanyProfile() {
  return (
    <div>
      <h2>This is company profile</h2>
    </div>
  );
}
